module.exports = __webpack_public_path__ + "static/media/bombbanner_sm1.d91538d5.png";